import React from 'react'
import styled from 'styled-components'
import { FlexCentered } from '~/components/common/containers'

import MeetLogo from '~/components/icons/meet-logo'
import { translate } from '~/core/translate'

const TitleContainer = styled(FlexCentered)`
  font-weight: 600;
  font-size: 15px;
  justify-content: center;
  margin-bottom: 24px;
  margin-top: 32px;
`

const Text = styled.span`
  margin-left: 12px;
`

const Title = () => (
  <TitleContainer>
    <FlexCentered>
      <MeetLogo size={24} />
      <Text>{translate('legal_footer_text')}</Text>
    </FlexCentered>
  </TitleContainer>
)

export default Title
